function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function defaultOptions() {
  return {
    email: true,
    phone: false,
    photo: true,
    passport: false,
    legal_review: false,
    online_signing: false,
    archive_contract: false
  };
}
function initialState() {
  return {
    step: 'select',
    plan: 'free',
    tierOwner: '',
    canChooseTier: true,
    options: defaultOptions(),
    signers: [],
    candidateIndex: null,
    you: null,
    identified: false,
    places: 0,
    verificationMethods: createMethods(defaultOptions()),
    signed: false,
    actionStatus: null,
    upsell: null,
    focus: 'email',
    checking: false,
    verifyError: '',
    devCode: '',
    pendingCode: '',
    history: []
  };
}
function go(state, step) {
  var patch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _objectSpread(_objectSpread(_objectSpread({}, state), patch), {}, {
    history: state.history.concat(state.step),
    step: step
  });
}
function back(state) {
  if (!state.history.length) {
    return state;
  }
  var history = state.history.slice();
  var step = history.pop();
  return _objectSpread(_objectSpread({}, state), {}, {
    history: history,
    step: step
  });
}
function selectPlan(state, plan) {
  if (state.canChooseTier === false) {
    return state;
  }
  if (plan !== 'free' && plan !== 'premium') {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    plan: plan
  });
}
function setShareOption(state, key, checked) {
  if (state.canChooseTier === false) {
    return state;
  }
  if (!state.options || !Object.prototype.hasOwnProperty.call(state.options, key)) {
    return state;
  }
  return updateRequirements(state, _defineProperty({}, key, checked === true));
}
function applyShareMetadata(state, metadata) {
  var _verificationMethods$;
  var options = defaultOptions();
  var plan = (metadata === null || metadata === void 0 ? void 0 : metadata.tier) === 'premium' ? 'premium' : 'free';
  var verification = (metadata === null || metadata === void 0 ? void 0 : metadata.verification) || {};
  options.email = verification.email !== false;
  options.phone = plan === 'premium' && verification.phone === true;
  options.photo = verification.photo === true;
  options.passport = verification.passport === true;
  options.legal_review = plan === 'premium' && verification.legal_review === true;
  options.online_signing = plan === 'premium' && (metadata === null || metadata === void 0 ? void 0 : metadata.online_signing) === true;
  options.archive_contract = plan === 'premium' && (metadata === null || metadata === void 0 ? void 0 : metadata.archive_contract) === true;
  var verificationMethods = createMethods(options);
  return _objectSpread(_objectSpread({}, state), {}, {
    plan: plan,
    options: options,
    verificationMethods: verificationMethods,
    focus: verificationMethods.some(function (method) {
      return method.id === state.focus;
    }) ? state.focus : ((_verificationMethods$ = verificationMethods[0]) === null || _verificationMethods$ === void 0 ? void 0 : _verificationMethods$.id) || 'email',
    tierOwner: String((metadata === null || metadata === void 0 ? void 0 : metadata.tier_owner) || '').trim()
  });
}
function confirmYou(state, you) {
  var signers = state.signers.map(function (signer) {
    if (signer.index !== you.index) {
      return signer;
    }
    return _objectSpread(_objectSpread({}, signer), {}, {
      email: you.email,
      publicKey: you.publicKey,
      identicon: you.identicon
    });
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    signers: signers,
    candidateIndex: null,
    you: you,
    identified: true
  });
}
function focusMethod(state, id) {
  var method = state.verificationMethods.find(function (item) {
    return item.id === id;
  });
  if (!method) {
    return state;
  }
  if (method.available) {
    return _objectSpread(_objectSpread({}, state), {}, {
      upsell: null,
      focus: method.id
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    upsell: id
  });
}
function toggleMethod(state, id, selected) {
  var verificationMethods = state.verificationMethods.map(function (method) {
    if (method.id !== id || !method.available) {
      return method;
    }
    return _objectSpread(_objectSpread({}, method), {}, {
      selected: selected
    });
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    verificationMethods: verificationMethods
  });
}
function updateRequirements(state, options) {
  var _verificationMethods$2;
  var nextOptions = _objectSpread(_objectSpread({}, state.options), options);
  var verificationMethods = createMethods(nextOptions);
  return _objectSpread(_objectSpread({}, state), {}, {
    options: nextOptions,
    verificationMethods: verificationMethods,
    focus: verificationMethods.some(function (method) {
      return method.id === state.focus;
    }) ? state.focus : ((_verificationMethods$2 = verificationMethods[0]) === null || _verificationMethods$2 === void 0 ? void 0 : _verificationMethods$2.id) || 'email'
  });
}
function createMethods() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var definitions = [{
    id: 'email',
    key: 'email',
    title: 'Email',
    description: 'Verify your email address'
  }, {
    id: 'mobile',
    key: 'phone',
    title: 'Mobile',
    description: 'Verify your mobile number'
  }, {
    id: 'photo',
    key: 'photo',
    title: 'Photo',
    description: 'Take a photograph with your camera. You can review it before it is saved with your verification.'
  }, {
    id: 'passport',
    key: 'passport',
    title: 'Passport',
    description: 'Upload the photo and identity page of your passport.'
  }, {
    id: 'thirdParty',
    key: 'legal_review',
    title: 'Legal review',
    description: 'Third-party identity review'
  }];
  return definitions.filter(function (method) {
    return options[method.key] === true;
  }).map(function (method) {
    return {
      id: method.id,
      title: method.title,
      description: method.description,
      tier: method.key === 'email' || method.key === 'photo' || method.key === 'passport' ? 'free' : 'premium',
      available: true,
      required: true,
      selected: true,
      status: 'pending'
    };
  });
}
function markMethodSent(state, id) {
  var verificationMethods = state.verificationMethods.map(function (method) {
    if (method.id !== id) {
      return method;
    }
    return _objectSpread(_objectSpread({}, method), {}, {
      status: 'sent',
      selected: true
    });
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    verificationMethods: verificationMethods
  });
}
function markMethodVerified(state, id) {
  var verificationMethods = state.verificationMethods.map(function (method) {
    if (method.id !== id) {
      return method;
    }
    return _objectSpread(_objectSpread({}, method), {}, {
      status: 'verified',
      selected: true
    });
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    verificationMethods: verificationMethods
  });
}
function currentMethod(state) {
  return state.verificationMethods.find(function (method) {
    return method.selected && method.status !== 'verified';
  }) || null;
}
function requiredComplete(state) {
  var required = (state.verificationMethods || []).filter(function (method) {
    return method.required;
  });
  return required.every(function (method) {
    return method.status === 'verified';
  });
}
var workflowStages = ['select', 'identity', 'sign', 'verify', 'share'];
function firstRequiredAction(requirements) {
  if (requirements.newDocument) {
    return 'select';
  }
  if (!requirements.identified) {
    return 'identity';
  }
  if (requirements.outstandingSignatures) {
    return 'sign';
  }
  if (!requirements.verificationComplete) {
    return 'verify';
  }
  return 'share';
}
function resolveInitial(state, requirements) {
  var step = firstRequiredAction(requirements);
  return _objectSpread(_objectSpread({}, state), {}, {
    step: step,
    history: workflowStages.slice(0, workflowStages.indexOf(step))
  });
}
function resolveAfter(state, completedStage, requirements) {
  var completedIndex = workflowStages.indexOf(completedStage);
  if (completedIndex < 0) {
    return state;
  }
  var later = workflowStages.slice(completedIndex + 1);
  var step = 'share';
  var _iterator = _createForOfIteratorHelper(later),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var candidate = _step.value;
      if (candidate === 'identity' && !requirements.identified) {
        step = candidate;
        break;
      }
      if (candidate === 'sign' && requirements.identified && requirements.outstandingSignatures) {
        step = candidate;
        break;
      }
      if (candidate === 'verify' && requirements.identified && !requirements.verificationComplete) {
        step = candidate;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    step: step,
    history: workflowStages.slice(0, workflowStages.indexOf(step))
  });
}
function advance(state) {
  if (state.step === 'select') {
    return go(state, 'share');
  }
  if (state.step === 'premium') {
    return go(state, 'sign', {
      plan: 'free'
    });
  }
  return state;
}
function learnPremium(state) {
  if (state.step === 'premium') {
    return state;
  }
  return go(state, 'premium');
}
function shareRows(state) {
  return state.signers.filter(function (signer) {
    return Number(signer.places) > 0;
  }).map(function (signer) {
    var you = state.you && signer.index === state.you.index;
    var signed = signer.signed === true || you && state.signed === true;
    return {
      name: signer.name || signer.email || 'Signer',
      email: signer.email || '',
      signed: signed,
      creator: signer.creator === true,
      index: signer.index,
      requirements: Array.isArray(signer.requirements) ? signer.requirements : []
    };
  });
}
module.exports = {
  initialState: initialState,
  back: back,
  selectPlan: selectPlan,
  setShareOption: setShareOption,
  applyShareMetadata: applyShareMetadata,
  confirmYou: confirmYou,
  focusMethod: focusMethod,
  toggleMethod: toggleMethod,
  updateRequirements: updateRequirements,
  markMethodSent: markMethodSent,
  markMethodVerified: markMethodVerified,
  currentMethod: currentMethod,
  requiredComplete: requiredComplete,
  firstRequiredAction: firstRequiredAction,
  resolveInitial: resolveInitial,
  resolveAfter: resolveAfter,
  go: go,
  advance: advance,
  learnPremium: learnPremium,
  shareRows: shareRows
};